module.exports = __webpack_public_path__ + "static/media/icon34.e0c4a369.png";